//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default{
    name: '',
    props:{
      active: {
        type: Number,
        default: 0
      }
    },
    data() {
       return {
         //active: 0, //底部當前
        icon: [
          {normal: require("@/assets/image/icon/icon_normal_discover.png"), selector: require("@/assets/image/icon/icon_selector_discover.png")},
          {normal: require("@/assets/image/icon/icon_normal_order.png"), selector: require("@/assets/image/icon/icon_selector_order.png")},
          {normal: require("@/assets/image/icon/icon_normal_me.png"), selector: require("@/assets/image/icon/icon_selector_me.png")}
        ],
        menu: [
          {icon: 'home', text: '首頁', link: '/home'},
          {icon: 'redeemed', text: this.$t('PAGE_HEADER_TITLE.buyBook'), link: '/myBook'},
          {icon: 'my', text: '我的', link: '/my'}
        ]
       }
    },
    created() {

    },

    methods: {
      gotoPage(link){
        if(link == this.$route.path){
          return
        }
        let obj = {};
        obj.router = this.$router;
        obj.path = this.$utils.splitUrl(link);
        this.GLOBAL_.ccApp.openTo(obj);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/tabBar.vue